import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FtaAdvisoryDetails, FtaAdvisoryDetailsBasedOnId } from '@shared-interfaces/fta-advisory';
import { Pageable } from '@shared-interfaces/pageable.interface';
import { EnvironmentService } from '@shared-services/environment.service';
import { GET, Path, Query, RebirthHttp } from 'rebirth-http';
import { environment } from 'src/environments/environment';
import { EMPTY, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FtaAdvisory extends RebirthHttp{

  constructor(http: HttpClient, private env: EnvironmentService) {
    super(http);
  }

  searchFTAAdvisory(ftaAdvisoryRequest: any, pageSize: number, pageIndex: number): Observable<Pageable<FtaAdvisoryDetails>> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('hsCode', ftaAdvisoryRequest.hsCode)
      .set('originCountryIso', ftaAdvisoryRequest.originCountryIso)
      .set('destinationCountryIso', ftaAdvisoryRequest.destinationCountryIso)
      .set('productBased', ftaAdvisoryRequest.productBased)
      .set('size', pageSize)
      .set('page', pageIndex-1)
      
    return this.http.get<Pageable<FtaAdvisoryDetails>>(envValue.wso2amEndPoint +"/unifiedsource" +envValue.wso2amApiVersion +"/api/v1/tariff/fta/search", {params: params});
  }

  getFTADetailsbyTariffCode(tariffCodeId: number, ftaAdvisoryRequest: any, pageSize: number, pageIndex: number, hscode?: string, hsDesc?: string): Observable<Pageable<FtaAdvisoryDetailsBasedOnId>>{
    const envValue:any = this.env.getEnvironment();
    let params, hsc;
    let desc = hsDesc?.length ? hsDesc : "";
    if(ftaAdvisoryRequest.productBased === "true"){
      hsc = hscode?.length ? hscode : ftaAdvisoryRequest.hsCode; 
    }
    else{
      hsc = hscode?.length ? hscode : "";
    }
    params = new HttpParams()
        .set('hsCode',hsc)
        .set('fullDescription', desc)
        .set('originCountryIso', ftaAdvisoryRequest.originCountryIso)
        .set('destinationCountryIso', ftaAdvisoryRequest.destinationCountryIso)
        .set('size', pageSize)
        .set('page', pageIndex-1)
    
    return this.http.get<Pageable<FtaAdvisoryDetailsBasedOnId>>(envValue.wso2amEndPoint +"/unifiedsource" +envValue.wso2amApiVersion +"/api/v1/tariff/fta/"+ tariffCodeId, {params: params});
  }

  @GET(
		environment.wso2amEndPoint +
		'/unifiedsource/api/v1/tariff/fta/:tariffCodeId/allowedOrigin'
	)
	getCountryList(@Path('tariffCodeId') tariffCodeId: number, @Query('destination') destination: string): any {
		return EMPTY;
	}

  @GET(
		environment.wso2amEndPoint + '/unifiedsource/api/v1/tariff/availableTariffs'
	)
	getTariffDetails(
    @Query('tarifcodeid') tariffCode: number,
    @Query('origin') originCountryIso: string,
    @Query('destination') destinationCountryIso: string, 
    @Query('hscode') hscode: string,
  ): any {
		return EMPTY;
	}
}
